export const barChartListPageOne = [
  {
    name: "CAPA Status - Regional Offices",
    yAxisName: "Count",
    xAxisName: "",
    value: "CAPADistributionAssignedRO",
    type: "stack",
    isMines: true,
    isHo: true,
  },
  {
    name: "CAPA Status - Mines",
    yAxisName: "Count",
    xAxisName: "",
    value: "CAPADistributionAssignedMines",
    type: "stack",
    isMines: true,
    isHo: false,
  },
  // {
  //   name: "CAPA Distribution (Completed) - Mines",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "CAPADistributionCompletedMines",
  //   type: "bar",
  // },
  // {
  //   name: "CAPA Distribution (Overdue) - Mines",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "CAPADistributionOverdueMines",
  //   type: "bar",
  // },

  // {
  //   name: "CAPA Distribution (Completed) - RO",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "CAPADistributionCompletedRO",
  //   type: "bar",
  // },
  // {
  //   name: "CAPA Distribution (Overdue) - RO",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "CAPADistributionOverdueRO",
  //   type: "bar",
  // },
  // {
  //   title: "Top 10 CAPAs - Areas of Operations - Mines",
  //   value: "Top10CAPAsAreasofOperationsMines",
  // },
  // {
  //   title: "Top 10 CAPAs - Areas of Operations - RO",
  //   value: "Top10CAPAsAreasofOperationsRO",
  // },
  // {
  //   name: "Top 5 Outstanding CAPA Owners",
  //   yAxisName: "Count",
  //   xAxisName: "Owner",
  //   value: "top5CAPAOutStandingOwners",
  //   type: "bar",
  // },
  {
    name: "CAPA Performance - Regional Offices",
    yAxisName: "Days",
    xAxisName: "",
    value: "averageCapaCompletionPeriodRo",
    type: "barWithLabel",
    isMines: true,
    customeTool: true,
    isHo: true,
  },
  {
    name: "CAPA Performance - Mines",
    yAxisName: "Days",
    xAxisName: "",
    value: "averageCapaCompletionPeriodMine",
    type: "barWithLabel",
    isMines: true,
    customeTool: true,
    isHo: false,
  },
  // {
  //   name: "Top 10 Mines - CAPA Area of Operationss",
  //   value: "Top10MinesCAPAAreaofOperations",
  //   type: "stack",
  // },
];
export const WigetList = [
  {
    name: "CAPA Open",
    key: "CAPAAssigned",
    value: "",
  },
  {
    name: "CAPA Completed",
    key: "CAPACompleted",
    value: "",
  },
  {
    name: "CAPA Overdue",
    key: "CAPAOverDue",
    value: "",
  },
  {
    name: "Completion Performance",
    key: "averageCapaCompletionPeriodWidget",
    value: "",
  },
];

export const pieListPageTwo = [
  {
    title: "CAPA - Top 10 Areas",
    value: "Top10CAPAsAreasofOperations",
    isScroll: true,
  },
  {
    title: "CAPA - Top 10 Owners",
    value: "Top10OwnerWithOutstandingCAPAs",
    isScroll: true,
  },
  {
    title: "CAPA - Status Count",
    value: "CAPAStatusCount",
  },
  {
    title: "CAPA Source Distribution",
    value: "CAPASourceTypeDistribution",
  },
  {
    name: "CAPA Completed - Last 12 months",
    yAxisName: "Days",
    xAxisName: "",
    value: "monthsWiseCapa",
    type: "barWithLabelMonth",
    isMines: true,
  },
];
